import type { JSX } from 'solid-js';

export type StockState = 'In Stock' | 'Low Stock' | 'Out of Stock';

export default function StockBadge(props: { status: StockState }): JSX.Element {
  const tone = () => {
    switch (props.status) {
      case 'In Stock':
        return 'bg-emerald-100 text-emerald-900 border-emerald-300';
      case 'Low Stock':
        return 'bg-amber-100 text-amber-900 border-amber-300';
      case 'Out of Stock':
        return 'bg-stone-100 text-stone-600 border-stone-300';
    }
  };
  return (
    <span
      class={`inline-block text-xs font-medium px-2 py-0.5 rounded-full border ${tone()}`}
      aria-label={`Stock status: ${props.status}`}
    >
      {props.status}
    </span>
  );
}
